import React, { Component } from "react";
import {
  Modal,
} from "react-bootstrap";
import { connect } from "react-redux";
import { TextField } from "@rmwc/textfield";
import { Checkbox } from "@rmwc/checkbox";
import * as actionCreator from "../../action/index.js";
import * as validate from "./validations.js";
import Likeactive from "../../assets/images/feedback/like-active.svg";
import Likenormal from "../../assets/images/feedback/like-normal.svg";
import confused from "../../assets/images/emoji/confused.svg";
import happy from "../../assets/images/emoji/happy.svg";
import love from "../../assets/images/emoji/love.svg";
import very_sad from "../../assets/images/emoji/sad.svg";
import sad from "../../assets/images/emoji/sad-2.svg";
import ConfettiExplosion from 'react-confetti-explosion';
import AnimButton from "../Button/AnimButton.js";
class DeletedStateManuModal extends React.Component {
   constructor(props) {
      super(props);
      this.state = {
         displayFeedBackError : {
            first_name: "",
            last_name: "qeqwe",
            email:"qweqwe",
            phone_number:"qweqwe",
         }
      };
   }


   custom(){
      document.getElementsByClassName("modal")[0].style.transform = "scale(0)"
      document.getElementsByClassName("modal")[0].style.transition = "0.6s"
      setTimeout(() => {
         this.props.handleShowfeedback("prompt")
      },500)
   }

   render() {
      const emojisArray = [very_sad, sad, confused, happy, love];

      return (
         <div>
         <Modal
            centered
            show={this.props.isShowDeletedStateManuModal}
            backdrop="static"
            keyboard={false}
            onHide={(e) => this.props.const_var.isShowDeletedStateManuModal = false}
            dialogClassName={
               this.props.isShowfeedbackloader == true
               ? "deleted-state-manufacture-modal react-modal form-submiting"
               : "deleted-state-manufacture-modal react-modal"
            }
            backdropClassName="ract-modal-pre-parent"
         >
            <button
               className="close"
               onClick={(e) =>  this.props.handleDeletedStateManuModal(false)}
            >
               <span className="icon-close"></span>
            </button>

            <Modal.Body
               className="improvemodal-wrapper"
            >  
               <div className="deleted-state-manufacture">
                  <div className="deleted-state-manufacture-inner">
                     <div className="deleted-state-manufacture-content">Oops! The changes you selected can't be applied because the chosen state or manufacturer is no longer available.</div>
                  </div>
               </div>
                  <button className='btn btn-primary deleted-state-manufacture-btn'
                      onClick={(e) =>{
                           this.props.handleDeletedStateManuModal(false);     
                        }}>
                           Okay
                  </button>     
            </Modal.Body>
         </Modal>
         </div>
      );
   }
}

const mapStoreToProps = (state) => {
  return state.reducer;
};



export default connect(mapStoreToProps, actionCreator)(DeletedStateManuModal);
